import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CalendarClock } from "lucide-react";
import { api, imgUrl } from "@/api";
import { useLang } from "@/i18n";

export default function ProgramPage() {
  const { t } = useLang();
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    api.get("/programs").then((r) => setPrograms(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 sm:py-20" data-testid="program-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-emerald-950 tracking-tight">{t("program.title")}</h1>
        <p className="text-slate-600 mt-3">{t("program.subtitle")}</p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        {programs.map((p, i) => (
          <motion.div
            key={p.id}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.07 }}
            className="group bg-white rounded-xl border border-emerald-900/10 shadow-sm overflow-hidden"
            data-testid={`program-card-${p.id}`}
          >
            <div className="aspect-[16/10] overflow-hidden bg-emerald-50">
              {p.image && <img src={imgUrl(p.image)} alt={p.nama} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />}
            </div>
            <div className="p-6 border-t-2 border-[#D4AF37]">
              <h3 className="font-display text-xl font-bold text-emerald-900">{p.nama}</h3>
              <p className="text-sm text-slate-600 mt-2 flex items-start gap-2">
                <CalendarClock className="h-4 w-4 text-[#D4AF37] shrink-0 mt-0.5" />
                <span>{p.pelaksanaan}</span>
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
